module.exports = __webpack_public_path__ + "static/media/bigBlueTemplate.153948c9.png";